package org.example.project.dashboard

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import org.example.project.utils.All

internal object DashboardProfileSettingsBridge {
    var feedDefinitionsWithStatus by mutableStateOf<List<Pair<DashboardFeedDefinition, Boolean>>>(emptyList())
        private set
    var userFeedPushEnabled by mutableStateOf<Map<String, Boolean>>(emptyMap())
        private set
    var startScreenOptions by mutableStateOf<List<All>>(emptyList())
        private set
    var selectedStartScreen by mutableStateOf("")
        private set

    var onFeedPushEnabledChange: ((String, Boolean) -> Unit)? = null
        private set
    var onFeedSettingsSave: ((Map<String, Boolean>) -> Unit)? = null
        private set
    var onStartScreenSave: ((String) -> Unit)? = null
        private set

    fun update(
        feedDefinitionsWithStatus: List<Pair<DashboardFeedDefinition, Boolean>>,
        userFeedPushEnabled: Map<String, Boolean>,
        startScreenOptions: List<All>,
        selectedStartScreen: String,
        onFeedPushEnabledChange: (String, Boolean) -> Unit,
        onFeedSettingsSave: (Map<String, Boolean>) -> Unit,
        onStartScreenSave: (String) -> Unit
    ) {
        this.feedDefinitionsWithStatus = feedDefinitionsWithStatus
        this.userFeedPushEnabled = userFeedPushEnabled
        this.startScreenOptions = startScreenOptions
        this.selectedStartScreen = selectedStartScreen
        this.onFeedPushEnabledChange = onFeedPushEnabledChange
        this.onFeedSettingsSave = onFeedSettingsSave
        this.onStartScreenSave = onStartScreenSave
    }
}
